var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "house_FILL0_wght100_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.85919 22V14.3628H3L9.30072 8.68262L12.9284 11.9762V9.87593H14.074V12.9786L15.6014 14.3628H14.7422V22H10.5418V17.2268H8.05967V22H3.85919ZM4.52745 21.3318H7.39141V16.5585H11.21V21.3318H14.074V13.8855L9.30072 9.58954L4.52745 13.8855V21.3318Z",
    fill: "#183883"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5334 7.24851V4.0824H10.5411V3.63894H12.9877V4.0824H11.9954V7.24851H11.5334Z",
    fill: "#183883"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3208 7.24851L13.6464 6.27392H14.9505L15.2761 7.24851H15.7625L14.5416 3.63894H14.0552L12.8344 7.24851H13.3208ZM14.2984 4.32231L14.8023 5.83046H13.7946L14.2984 4.32231Z",
    fill: "#183883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9746 5.42825L15.817 7.24851H16.352L17.2421 5.85109L18.1273 7.24851H18.6624L17.5096 5.42825L18.6429 3.63894H18.1079L17.2421 5.00542L16.3715 3.63894H15.8364L16.9746 5.42825Z",
    fill: "#183883"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.86892 2C9.02794 2 8.34619 2.72723 8.34619 3.62431V7.05827C8.34619 7.95535 9.02794 8.68258 9.86892 8.68258H19.234C20.0749 8.68258 20.7567 7.95535 20.7567 7.05827V3.62431C20.7567 2.72723 20.0749 2 19.234 2H9.86892ZM8.68458 3.62431C8.68458 2.92658 9.21483 2.36096 9.86892 2.36096H19.234C19.8881 2.36096 20.4183 2.92658 20.4183 3.62431V7.05827C20.4183 7.756 19.8881 8.32162 19.234 8.32162H9.86892C9.21483 8.32162 8.68458 7.756 8.68458 7.05827V3.62431Z",
    fill: "#183883"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/House.c68e573614347307cd0e935fce64fca9.svg";
export { ForwardRef as ReactComponent };